import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { connect } from 'react-redux';

const DeleteEquipmentDialog = ({
  open,
  column,
  editing,
  setCurrentlyEditing,
  setCurrentEditor,
}) => {
  if (!editing || editing.length <= 0) return null;
  const emptyStagingEquipment = editing.filter((equip) => equip.points.length === 0);
  if (emptyStagingEquipment.length <= 0) return null;
  const action = column;

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" component="label" htmlFor="myField">
          {emptyStagingEquipment.length} empty equipment will be deleted
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button
          variant="contained"
          onClick={() => action.doClose({ setCurrentlyEditing, setCurrentEditor })}
          color="error"
          disabled={false}
        >
          Abort
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            action.doSave(emptyStagingEquipment);
            action.doClose({ setCurrentlyEditing, setCurrentEditor });
          }}
          color="success"
          disabled={false}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  promotedEquipmentById: state.entities.equipment.byId ?? {},
});

export default connect(mapStateToProps)(DeleteEquipmentDialog);
